import {billEmail, getBillsByMonthList, printBilling} from "../../../api/admin/billingReq";
import useData from "../../../hooks/useData";
import useAuth from "../../../hooks/useAuth";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";


export default function BillingDetails({ dataId, location }) {
    const { data, setData,
        billingSearchList
    } = useData();
    const { auth } = useAuth();
    const token = auth.token;
    const [ pdf, setPdf ] = useState({});
    const [ showModal, setShowModal ] = useState(false);

    const apiBillsByMonthList = async () => {
        const response = await getBillsByMonthList(token, dataId);
        setData(response);
    }

    useEffect(() => {
        if (dataId !== 0) {
            apiBillsByMonthList();
       }
    }, [ dataId ]);

    const handleSelectLine = (id) => {
        const lines = document.querySelectorAll(".facturation-detail tr");
        lines.forEach(line => line.classList.remove("selected"));
        const line = document.getElementById(id);
        line.classList.add("selected");
    }

    const handlePrint = (e) => {
        e.preventDefault()
        const id = e.target.id;
        printBilling(token, id)
            .then(response => {
                setPdf(response)
                if (pdf) {
                    setShowModal(true)
                }
            });
    }

    const handleMailOne = (e) => {
        e.preventDefault()
        let id = e.target.id;
        let invoiceNumber = e.target.getAttribute("data");
        let body = {
            billId: id,
            invoiceNumber: invoiceNumber,
        }
        billEmail(token, body)
    }

    const handleRemoveModal = () => {
        setShowModal(false)
    }

    return (
        <>
            { showModal &&
                <div className="modal">
                    <div className="pdf-view">
                        <iframe title="Détail de la facture" src={pdf} width="100%" height="100%"></iframe>
                        <div className="buttons-container back">
                            <button onClick={handleRemoveModal}><i className="fa fa-arrow-left"/><span>Retour</span></button>
                        </div>
                    </div>
                </div>
            }
            <div className="dashboard">
                <table className="facturation">
                    <thead>
                    <tr>
                        <th className="agence-th">Agence</th>
                        <th className="date-th">Date</th>
                        <th className="ttc-th">Total TTC</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {(data != 0 && billingSearchList?.length < 1) ?
                        <>
                            {data?.map((bill,index) => (
                                <tr key={index} id={bill.id} onClick={() => handleSelectLine(bill.id)}>
                                    <td className="agence-th">{bill.name} ( {bill.zipcode} {bill.city} )</td>
                                    <td className="date-th">{bill.date}</td>
                                    <td className="ttc-th">{parseFloat(bill.totalTtc).toFixed(2)}</td>
                                    <td>

                                        <Link to={`/admin/facturation/${bill.id}/voir`}><i className="fa fa-eye"></i></Link>

                                        <i id={bill?.id} className="fa fa-print" onClick={handlePrint}></i>
                                        <i id={bill?.id} data={bill?.invoiceNumber} className="fa fa-paper-plane"
                                           onClick={handleMailOne}>
                                        </i>
                                    </td>
                                </tr>
                            ))}
                        </> :
                        location === "Recherche de facturation" && billingSearchList?.length > 0 ?
                            <>
                                {billingSearchList?.map(bill => (
                                    <tr id={bill.id} onClick={() => handleSelectLine(bill.id)}>
                                        <td className="agence-th">{bill.name} ( {bill.zipcode} {bill.city} )</td>
                                        <td className="date-th">{bill.date}</td>
                                        <td className="ttc-th">{parseFloat(bill.totalTtc).toFixed(2)}</td>
                                        <td>

                                            <Link to={`/admin/facturation/${bill.id}/voir`} state={{ fromSearch: true }}><i className="fa fa-eye">
                                            </i></Link>

                                            <i id={bill?.id} className="fa fa-print" onClick={handlePrint}></i>
                                            <i id={bill?.id} data={bill?.invoiceNumber} className="fa fa-paper-plane"
                                               onClick={handleMailOne}>
                                            </i>
                                        </td>
                                    </tr>
                                ))}
                            </>
                            : <span className="nodata-span">Pas de factures pour cette période</span>
                    }
                    </tbody>
                </table>
            </div>

        </>

    )
}